import { render } from "./OAuthApplicationDetail.vue?vue&type=template&id=8ead77c8"
import script from "./OAuthApplicationDetail.vue?vue&type=script&lang=js"
export * from "./OAuthApplicationDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__